import { IMessageSimplified } from "./worker/worker.types";
import { ITask } from "./ws.types";
import { SUBSCRIPTION_CONFIG } from "./ws_subscriptions";

export const convertMessageDataToTask = (messageData: {
  alias?: string;
  message: IMessageSimplified;
}): ITask | null => {
  const { alias, message } = messageData;

  if (!alias) {
    return null;
  }

  const handler = SUBSCRIPTION_CONFIG.find(
    (entry) => entry.alias === alias,
  )?.alias;

  if (!handler) {
    return null;
  }

  return {
    body: JSON.parse(message.body),
    handler,
  };
};
